import { useRef } from 'react';
import useInlineScript from '@/hooks/useInlineScript';
import { type IEmbedImgur } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Imgur ({
  id,
  text,
}: IEmbedImgur) {
  const ref = useRef<HTMLDivElement>(null);

  useInlineScript(ref, '<script async src="https://s.imgur.com/min/embed.js"></script>');

  return (
    <div className={styles['imgur']} ref={ref}>
      <blockquote className='imgur-embed-pub' data-id={id}>
        <a href={`//imgur.com/${id}`}>{text}</a>
      </blockquote>
    </div>
  );
}
